import React from 'react'

const VaultFeatures = () =>
  <div className="page feature">
    <h1>Vault</h1>
  </div>

export default VaultFeatures
